import React from 'react';
import { node, oneOf } from 'prop-types';
import { Popover } from '@fiverr-private/fit';
import Menu from '../Menu';
import DropdownTrigger from './DropdownTrigger';
import DropdownButton from './DropdownButton';

export const POSITIONS = {
    RIGHT: 'right',
    LEFT: 'left',
    TOP_RIGHT: 'top-right',
    TOP_LEFT: 'top-left'
};

const positionMap = {
    [POSITIONS.LEFT]: Popover.POSITIONS.BOTTOM_LEFT,
    [POSITIONS.RIGHT]: Popover.POSITIONS.BOTTOM_RIGHT,
    [POSITIONS.TOP_RIGHT]: Popover.POSITIONS.TOP_RIGHT,
    [POSITIONS.TOP_LEFT]: Popover.POSITIONS.TOP_LEFT
};

/**
 * @deprecated Please use Dropdown from @fiverr-private/dropdown instead.
 */
const Dropdown = ({ children, menu, position = POSITIONS.LEFT, ...props }) => (
    <Popover position={positionMap[position]} content={menu} {...props}>
        {children}
    </Popover>
);

Dropdown.displayName = 'Dropdown';

Dropdown.propTypes = {
    /**
     * The trigger of the dropdown
     */
    children: node.isRequired,
    /**
     * The dropdown position
     */
    position: oneOf(Object.values(POSITIONS)),
    /**
     * The dropdown menu, for details see Menu component
     */
    menu: node.isRequired
};

Dropdown.Trigger = DropdownTrigger;
Dropdown.Button = DropdownButton;
Dropdown.Menu = Menu;
Dropdown.MenuItem = Menu.Item;
Dropdown.MenuDivider = Menu.Divider;

Dropdown.POSITIONS = POSITIONS;

export default Dropdown;
